import { FC } from 'react';

type Props = {
	className?: string;
};

const NewsIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='inherit'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.0527 2.74316C11.0376 2.74314 11.8499 2.74312 12.4926 2.82935C13.1676 2.91987 13.7636 3.11724 14.2409 3.59338C14.7181 4.06951 14.9159 4.66417 15.0067 5.3375C15.0479 5.6436 15.0694 5.9882 15.0808 6.37166C15.0808 6.37166 16.0411 6.37157 16.3872 6.41799C16.765 6.46866 17.1525 6.58632 17.47 6.90305C17.7874 7.21977 17.9054 7.60643 17.9562 7.98333C18.0027 8.32854 18.0027 8.75508 18.0026 9.22973V15.0801C18.0026 16.2824 17.0256 17.2572 15.8204 17.2572H7.04043C6.05544 17.2572 5.24322 17.2572 4.60038 17.171C3.92549 17.0805 3.32944 16.8831 2.8522 16.4069C2.37495 15.9308 2.17712 15.3362 2.08639 14.6628C1.99996 14.0215 1.99998 13.2112 2 12.2285V7.77182C1.99998 6.78916 1.99996 5.97883 2.08639 5.3375C2.17712 4.66417 2.37495 4.06951 2.8522 3.59338C3.32944 3.11724 3.92549 2.91987 4.60038 2.82935C5.24321 2.74312 6.05543 2.74314 7.04038 2.74316H10.0527ZM15.8211 15.8058C16.2228 15.8058 16.5485 15.4808 16.5485 15.0801V9.27446C16.5485 8.74079 16.547 8.41352 16.515 8.17669C16.487 7.96852 16.4471 7.93376 16.4423 7.92965L16.4416 7.92892C16.4375 7.92421 16.4026 7.8844 16.194 7.85641C15.9567 7.82456 15.6286 7.82302 15.0937 7.82302V15.0801C15.0937 15.4808 15.4193 15.8058 15.8211 15.8058ZM5.53546 6.4647C5.22716 6.4647 4.97723 6.71463 4.97723 7.02293C4.97723 7.33123 5.22716 7.58116 5.53546 7.58116H11.4899C11.7982 7.58116 12.0481 7.33123 12.0481 7.02293C12.0481 6.71463 11.7982 6.4647 11.4899 6.4647H5.53546ZM5.53546 9.44193C5.22716 9.44193 4.97723 9.69187 4.97723 10.0002C4.97723 10.3085 5.22716 10.5584 5.53546 10.5584H11.4899C11.7982 10.5584 12.0481 10.3085 12.0481 10.0002C12.0481 9.69187 11.7982 9.44193 11.4899 9.44193H5.53546ZM5.53546 12.4192C5.22716 12.4192 4.97723 12.6691 4.97723 12.9774C4.97723 13.2857 5.22716 13.5356 5.53546 13.5356H8.51269C8.82098 13.5356 9.07092 13.2857 9.07092 12.9774C9.07092 12.6691 8.82098 12.4192 8.51269 12.4192H5.53546Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default NewsIconSolid;
